// Denials Management & Appeals Module (Módulo G — BillingV2)
// Worklist de denials (835), causa raíz, apelaciones y tracking de recuperación.

import DenialsManagementPage from "./pages/DenialsManagementPage";

// Export routes for AppRouter
export const denialsManagementRoutes = [
  {
    path: "/denials-management",
    element: <DenialsManagementPage />,
  },
];

// Export components for external use
export { default as DenialsManagementPage } from "./pages/DenialsManagementPage";

// Export utilities
export * from "./common/constants";
